<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div class="box box-info">
      <form>
        <div class="p-fluid p-formgrid p-grid p-mt-2">
          <div class="p-field p-col-12 p-md-2">
            <label for="date">Bank Account</label>
            <Dropdown v-model="account" :options="bankList"
                      optionLabel="name" :filter=true placeholder="Select Bank">
            </Dropdown>

          </div>
          <div class="p-field p-col-12 p-md-2">
            <label>From Date</label>
            <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
            <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="fromDate" v-model="fromDate"/>
          </div>
          <div class="p-field p-col-12 p-md-2">
            <label>To Date</label>
            <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
            <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate"/>
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button type="submit" @click.prevent="searchPartyStatement"
                    class="p-button-raised p-button-rounded" label="Search" icon="pi pi-search"/>
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button v-if="this.postDateChequeList.length > 0" @click.prevent="reset"
                    class="p-button-raised p-button-warning" label="Reset" icon="pi pi-refresh"/>
          </div>
        </div>
      </form>
      <!-- DataTable for PartyStatement -->
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-col-12">
          <DataTable :value="postDateChequeList"
                     :paginator="true"
                     :rows="10" :filters="filters"
                     class="p-datatable-responsive-demo p-datatable-customers"
                     data-key="id">
            <template #empty>No record found</template>
            <!-- <Column header="S.N" /> -->
            <Column :sortable="true" header="Miti" field="transactionDateNepali" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['transactionDateNepali']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Date" field="transactionDate" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['transactionDate']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Vou Type" field="moduleType" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['moduleType']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Voucher" field="voucher" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['voucher']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Particulars" field="accountName" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['accountName']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Cheque Date" field="chequeDate" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['chequeDate']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Cheque Number" field="chequeNumber" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['chequeNumber']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Deposited" bodyStyle="color:#00a65a;text-align: right" field="debitBalance"
                    filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['debitBalance']"/>
              </template>
            </Column>
            <Column :sortable="true" header="Withdraw" bodyStyle="color:#dd4b39;text-align: right" field="creditBalance"
                    filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['creditBalance']"/>
              </template>
            </Column>
            <Column header="Clear Date" field="chequeClearingDate">
            </Column>
            <Column header="Action">
              <template #body="slotProps">
                <Button class="p-button-raised p-button-success"
                        @click.prevent="openChequeDialog(slotProps.data)" icon="pi pi-pencil"/>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
      <Dialog header="Cheque Clearance Date" :visible.sync="editing" @show="setDateForDialog"
              :style="{width: '40vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-4">
            <label for="chequeclearDate">Cheque ClearDate:</label>
            <date-picker v-model="clearDate" v-if="!englishDateEnabled" valueType="format"/>
            <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="chequeclearDate"
                       v-model="clearDate"/>
          </div>
        </div>
        <template #footer>
          <Button class="p-button-raised p-button-success" @click.prevent="addChequeClearDate"
                  label="Save" icon="pi pi-save"/>
          <Button class="p-button-raised p-button-danger" @click.prevent="cancelChequeClearDate"
                  label="Cancel"/>
        </template>
      </Dialog>

      <div class="p-fluid p-formgrid p-grid ">
        <div class="p-field p-col-12 p-md-6"></div>
        <div class="p-field p-col-12 p-md-4"></div>
        <div class="p-field p-col-12 p-md-2 p-mt-5">
          <Button class="p-button-raised p-button-success" @click="postDateCheque" label="Post"/>
        </div>
      </div>
    </div>

  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import Dialog from 'primevue/dialog'
import Textarea from 'primevue/textarea'
import Button from 'primevue/button'

export default {
  data() {
    return {
      loading: false,
      fromDate: null,
      toDate: null,
      clearDate: null,
      postDateChequeList: [],
      bankList: [],
      account: '',
      accountMasterId: null,
      filters: {},
      editing: false,
      id: null,
      englishDateEnabled: true
    }
  },
  mounted() {
    this.bank()
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
  },
  methods: {
    async bank() {
      let response = await this.$store.dispatch('loadBankList')
      this.bankList = response.data.data
    },
    async searchPartyStatement() {
      if (this.account === '') {
        this.accountMasterId = 0
      } else {
        this.accountMasterId = this.account.id
      }
      let bankStatementObject = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        bankId: this.accountMasterId
      }
      if (this.account === '') {
        this.$toast.add({
          severity: 'error',
          summary: '',
          detail: 'Please select at least one bank account!',
          life: 10000
        })
        return
      }
      this.loading = true
      let response = await this.$store.dispatch('loadPostDateChequeUnCleared', bankStatementObject)
      this.loading = false
      this.postDateChequeList = response.data.data
      if (response.data.status === 'ERROR') {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 3000})
      } else if (response.data.data.length <= 0) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'No list available!', life: 3000})
      }
    },
    addChequeClearDate() {
      this.postDateChequeList.forEach(pdc => {
        if (pdc.id === this.id) {
          pdc.chequeClearingDate = this.clearDate
          pdc.chequeClearingDateNepali = this.clearDate
          this.editing = false
        }
      })
    },
    openChequeDialog(data) {
      this.editing = true
      this.id = data.id
      this.clearDate = data.chequeDate
      // // debugger
    },
    cancelChequeClearDate() {
      this.editing = false
    },
    async postDateCheque() {
      // console.log(this.postDateChequeList)
      // // debugger
      this.loading = true
      let response = await this.$store.dispatch('addPostChequeDate', this.postDateChequeList)
      this.loading = false
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
      }
    },
    setDateForDialog() {
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
      }
      if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      }
      if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
        this.setEnglishDate()
      }
    },
    setNepaliDate() {
      this.fromDate = this.$store.getters.startDate
      this.toDate = this.$store.getters.nepaliNewDate
      this.clearDate = this.$store.getters.nepaliNewDate
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
      this.clearDate = new Date().toISOString().slice(0, 10)
    },
    reset() {
      this.bankStatementReportList = []
      this.account = ''
      if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      } else {
        this.setEnglishDate()
      }
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      if (!this.$store.state.isEnglishDateEnabled || this.$store.state.isEnglishDateEnabled === 'false') {
        $('#fromDate').nepaliDatePicker({
          ndpYear: true,
          ndpMonth: true,
          ndpYearCount: 10,
          disableBefore: this.$store.state.startDate,
          disableAfter: this.$store.state.endDate,
          onChange: () => {
            this.fromDate = $('#fromDate').val()
          }
        })
        $('#toDate').nepaliDatePicker({
          ndpYear: true,
          ndpMonth: true,
          ndpYearCount: 10,
          disableBefore: this.$store.state.startDate,
          disableAfter: this.$store.state.endDate,
          onChange: () => {
            this.toDate = $('#toDate').val()
          }
        })
        if (this.postDateChequeList.length > 0) {
          $('#chequeclearDate').nepaliDatePicker({
            ndpYear: true,
            ndpMonth: true,
            ndpYearCount: 10,
            disableBefore: this.$store.state.startDate,
            disableAfter: this.$store.state.endDate,
            onChange: () => {
              this.clearDate = $('#chequeclearDate').val()
            }
          })
        } else {
          this.clearDate = ''
        }
      }
    }
  },
  components: {
    Dropdown,
    DatePicker,
    DataTable,
    Column,
    InputText,
    InputMask,
    Dialog,
    Button,
    Textarea
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">
</style>



// WEBPACK FOOTER //
// postDatedCheque.vue?088d9647